import { amountAsCurrency, Currency } from "currency";
import { FlatList, View } from "react-native";
import { List, useTheme, Text, Divider } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import InfoText from "./InfoText";
import Label from "../../../../components/Label";
import Multientrega from "../../components/Multientrega";
import useDeliveryFulfillments from "../../contexts/DeliveryFulfillmentsContext";
import { Carrier } from "../../types";

export default function FulfillmentOptions() {
  const tailwind = useTailwind();
  const { fulfillmentOptions, pickupAddress } = useDeliveryFulfillments();

  function details() {
    if (fulfillmentOptions.length) {
      return undefined;
    }

    const verb = pickupAddress ? "Edita" : "Agrega";
    return `${verb} la dirección de recogida para mostrarte las tárifas que aplican.`;
  }

  return (
    <View style={tailwind("gap-4")}>
      <InfoText title="Tarifas de envío" details={details()} />
      <FlatList
        data={fulfillmentOptions}
        ItemSeparatorComponent={Divider}
        scrollEnabled={false}
        renderItem={({ item }) => (
          <List.Item
            title={item.description}
            description={() => (
              <View style={tailwind("my-1 gap-1")}>
                <CarrierLogo carrier={item.carrier_name} />
                <HiddenLabel published={item.published} />
              </View>
            )}
            right={() => (
              <PriceLabel amount={item.price} currency={item.currency} />
            )}
          />
        )}
      />
    </View>
  );
}

function PriceLabel({
  amount,
  currency,
}: {
  amount: number;
  currency: Currency;
}) {
  const tailwind = useTailwind();
  const { colors } = useTheme();
  const color = colors.onSurfaceVariant;

  return (
    <Text variant="bodySmall" style={[tailwind("self-center"), { color }]}>
      {amount === 0 ? "Gratis" : amountAsCurrency({ amount, currency })}
    </Text>
  );
}

function HiddenLabel({ published }: { published: boolean }) {
  const tailwind = useTailwind();

  if (published) return null;

  return (
    <View style={tailwind("flex-row")}>
      <Label name="Oculto" />
    </View>
  );
}

function CarrierLogo({ carrier }: { carrier: Carrier }) {
  switch (carrier) {
    case "multientrega":
      return <Multientrega scale={0.7} />;
    default:
      return null;
  }
}
